module.exports = __webpack_public_path__ + "img/icon-generic-ring.63ec30fd.svg";